export interface Notification {
  text: string | string[];
  timeout?: number;
  color?: string;
  icon?: string;
  y?: "top" | "bottom" | undefined;
  x?: "left" | "right" | undefined;
}

export const NotificationDefault: Notification = {
  text: "",
  timeout: 3000,
  color: "primary",
  y: "top"
};

export interface ModalNotification {
  title: string;
  body: string;
  captionButton: string;
  titleClass?: string;
}

export interface ModalConfirm {
  title: string;
  icon?: string;
  body: string;
  bodyParams?: { [key: string]: string };
  titleClass?: string;
}

export interface ModalIntegrationPopUp {
  title?: string;
  status?: string;
  message?: string;
  description?: string;
  justifyContent?: string;
  accept?: string;
  cancel?: string;
  icon?: {
    name?: string;
    size?: string;
    color?: string;
  };
  cancelButton?: boolean;
  acceptButton?: boolean;
  titleClass?: string;
}
